import instance from "./api";

export const fetchAllAdmins = () =>
  instance.get("/admin/all-admin").then((r) => r.data?.data?.admin ?? []);

export const createNewAdmin = (data) =>
  instance.post("/admin/signup", data).then((r) => r.data);

export const addPermissions = (data) =>
  instance.patch("/admin/add-permissions", data).then((r) => r.data);

export const fetchAdminById = () =>
  instance.get(`/admin/admin-profile`).then((r) => {
    return r.data ?? {};
  });
